import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack
} from "@mui/material";
import { useTranslation } from "react-i18next";

const StructuresFilters = ({
  structureTypeFilterOptions,
  parentStructureFilterOptions,
  selectedStructureTypeId,
  selectedParentId,
  onStructureTypeChange,
  onParentIdChange,
  onClearFilters
}) => {
  const hasActiveFilters = selectedStructureTypeId || selectedParentId;

  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
      <FormControl sx={{ minWidth: 250 }}>
        <InputLabel size="small">
          {t("denominations.structures.filterByStructureType")}
        </InputLabel>
        <Select
          value={selectedStructureTypeId}
          label="Filter by Structure Type"
          onChange={onStructureTypeChange}
          size="small"
        >
          {structureTypeFilterOptions.map(option => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.optionLabel}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 250 }}>
        <InputLabel size="small">
          {t("denominations.structures.filterByParentStructure")}
        </InputLabel>
        <Select
          value={selectedParentId}
          label="Filter by Parent Structure"
          onChange={onParentIdChange}
          size="small"
        >
          {parentStructureFilterOptions.map(option => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.optionLabel}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {hasActiveFilters && (
        <Button variant="outlined" onClick={onClearFilters} size="small">
          {t("denominations.structures.clearFilters")}
        </Button>
      )}
    </Stack>
  );
};

export default StructuresFilters;
